import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import uuid from "uuid";
import linkState from 'linkstate';
import './admin-posts.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import RichTextEditor from '../../components/RichTextEditor/RichTextEditor';
import { convertHtmlToEditorJS, convertEditorJSToHtml } from '../../utils/editorConverter';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import MultiImageUpload from '../../components/MultiImageUpload/MultiImageUpload';
import { Box, Typography } from '@material-ui/core';
import API from '../../api/api';

const garageApi = new API();

class AdminPostsDialog extends Component {
  constructor(props) {
    super(props);

    this.isAddMode = true;

    this.state = {
      post: {
        unikey: '',
        title: '',
        description: '',
        text: null,
        image: 0,
      },
      extraImages: [],
      loading: true,
      snackBar: false,
      snackBarMessage: 'Alle Felder müssen ausgefüllt sein!',
      snackBarSeverity: 'warning',
      originalImageId: null,
      uploadStatus: null,
    };

    if (Object.keys(props.postsData).length >= 1) {
      this.isAddMode = false;
      const textData = convertHtmlToEditorJS(props.postsData.text);

      let originalImageId = null;
      let imageObject = null;

      if (props.postsData.image) {
        if (typeof props.postsData.image === 'object' && props.postsData.image.id) {
          originalImageId = props.postsData.image.id;
          imageObject = props.postsData.image;
        } else if (typeof props.postsData.image === 'number') {
          originalImageId = props.postsData.image;
        }
      }

      this.state.post = {
        ...props.postsData,
        text: textData,
        image: originalImageId || props.postsData.image || 0,
        imageObject,
      };
      this.state.originalImageId = originalImageId;
      this.state.extraImages = Array.isArray(props.postsData.images) ? props.postsData.images : [];
      this.state.loading = false;
    } else {
      this.state.post.unikey = uuid.v4();
      this.state.loading = false;
    }
  }

  componentDidMount() {
    garageApi.endpoints.image.uploadStatus()
      .then((res) => {
        this.setState({ uploadStatus: res.data });
        if (res.data && res.data.ok === false) {
          this.showSnackBar(res.data.message || 'Upload-Verzeichnis auf dem Server nicht beschreibbar', 'error');
        }
      })
      .catch(() => {});
  }

  showSnackBar(message, severity = 'warning') {
    this.setState({ snackBar: true, snackBarMessage: message, snackBarSeverity: severity });
  }

  handleImageUpload = (uploadData) => {
    if (!uploadData || uploadData.cleared || !uploadData.id) {
      this.setState({
        post: { ...this.state.post, image: 0, imageObject: null },
      });
      return;
    }
    this.setState({
      post: { ...this.state.post, image: uploadData.id, imageObject: uploadData },
    });
  };

  handleImageUploadError = (error) => {
    const msg = error?.response?.data?.message || error?.message || 'Fehler beim Hochladen des Anzeigebilds';
    this.showSnackBar(msg, 'error');
  };

  handleExtraImagesChange = (images) => {
    this.setState({ extraImages: images });
  };

  handleExtraImagesError = (error) => {
    this.showSnackBar(error?.message || 'Fehler beim Hochladen', 'error');
  };

  handleEditorChange = (editorData) => {
    this.setState({
      post: { ...this.state.post, text: editorData },
    });
  };

  submitDialog() {
    const postData = { ...this.state.post };
    const extraImageIds = this.state.extraImages.map((img) => img.id).filter(Boolean);

    if (postData.text && typeof postData.text === 'object') {
      postData.text = convertEditorJSToHtml(postData.text);
    }

    if (!this.isAddMode) {
      if (postData.image === this.state.originalImageId) {
        delete postData.image;
      } else if (postData.image && typeof postData.image === 'object' && postData.image.id) {
        postData.image = postData.image.id;
      }
    } else if (postData.image && typeof postData.image === 'object' && postData.image.id) {
      postData.image = postData.image.id;
    }

    delete postData.imageObject;
    delete postData.images;

    if (
      postData.title === ''
      || postData.description === ''
      || !postData.text
      || (this.isAddMode && (!postData.image || postData.image === 0))
    ) {
      this.showSnackBar('Alle Pflichtfelder ausfüllen (Titel, Beschreibung, Inhalt, Anzeigebild)', 'warning');
      return;
    }

    this.props.submit(this.isAddMode, postData, extraImageIds);
  }

  closeSnackBar(event, reason) {
    if (reason === 'clickaway') return;
    this.setState({ snackBar: false });
  }

  render() {
    const { uploadStatus } = this.state;

    return (
      <div>
        <DialogTitle id="form-dialog-title">
          Nachricht {this.isAddMode ? 'Erstellen' : 'Bearbeiten'}
        </DialogTitle>
        {this.state.loading ? <LinearProgress color="primary" /> : <span className="loader-span" />}
        <DialogContent style={{ minWidth: '600px', maxHeight: '85vh' }}>
          {uploadStatus && uploadStatus.ok === false && (
            <Box style={{ marginBottom: 16, padding: 12, background: '#fff3e0', borderRadius: 8 }}>
              <Typography variant="body2" color="error">
                Server-Upload-Problem: {uploadStatus.message}
              </Typography>
            </Box>
          )}

          <Box style={{ marginBottom: '20px' }}>
            <TextField
              autoFocus
              margin="dense"
              id="title"
              label="Titel"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.post.title || ''}
              onInput={linkState(this, 'post.title')}
            />
          </Box>
          <Box style={{ marginBottom: '20px' }}>
            <TextField
              margin="dense"
              id="description"
              multiline
              rows={4}
              label="Beschreibung (Teaser)"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.post.description || ''}
              onInput={linkState(this, 'post.description')}
            />
          </Box>
          <Box style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Inhalt</label>
            <RichTextEditor
              data={this.state.post.text}
              onChange={this.handleEditorChange}
              placeholder="Schreiben Sie hier den Inhalt der Nachricht…"
            />
          </Box>
          <Box style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
              Anzeigebild (Pflicht)
            </label>
            <ImageUpload
              type="post"
              name="Post-Cover"
              label="Anzeigebild hierher ziehen oder klicken"
              onUploadComplete={this.handleImageUpload}
              onUploadError={this.handleImageUploadError}
              currentImage={
                this.state.post.imageObject
                  ? this.state.post.imageObject
                  : (this.state.post.image && typeof this.state.post.image === 'object'
                    ? this.state.post.image
                    : null)
              }
              maxSizeMB={64}
            />
          </Box>
          <Box style={{ marginBottom: '8px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
              Weitere Bilder (optional, beliebig viele)
            </label>
            <MultiImageUpload
              type="post"
              name="Post-Gallery"
              label="Weitere Bilder hierher ziehen oder klicken"
              images={this.state.extraImages}
              onChange={this.handleExtraImagesChange}
              onError={this.handleExtraImagesError}
              maxSizeMB={64}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <div className="p-line-end">
            <Button variant="contained" onClick={this.props.close}>
              Abbrechen
            </Button>
            <span />
            <Button variant="contained" color="primary" onClick={() => { this.submitDialog(); }}>
              Speichern
            </Button>
          </div>
        </DialogActions>
        <Snackbar open={this.state.snackBar} autoHideDuration={6000} onClose={this.closeSnackBar.bind(this)}>
          <MuiAlert elevation={6} variant="filled" onClose={this.closeSnackBar.bind(this)} severity={this.state.snackBarSeverity}>
            {this.state.snackBarMessage}
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

export default AdminPostsDialog;
